// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfo,
    CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfoFromJSON,
    CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfoToJSON,
    CollectionPatientAccountStatementDetailCollectionPaymentAllocation,
    CollectionPatientAccountStatementDetailCollectionPaymentAllocationFromJSON,
    CollectionPatientAccountStatementDetailCollectionPaymentAllocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface CollectionPatientAccountStatementDetailCollectionClaim
 */
export interface CollectionPatientAccountStatementDetailCollectionClaim {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    claimId?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    patientResponsibilityAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    pendingPatientResponsibilityAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    patientAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    patientAllocatedAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    discountAdjustmentAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    writeOffAdjustmentAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    claimAdjudicationStatus?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    guarantorAdjudicationStatus?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    fromDos?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    throughDos?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    patientFacingMemo?: string;
    /**
     * 
     * OpenAPI data type: {CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfo}
     * @type {CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfo}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    serviceLineInfo?: CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfo;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<CollectionPatientAccountStatementDetailCollectionPaymentAllocation>}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    collectionPaymentAllocations?: Array<CollectionPatientAccountStatementDetailCollectionPaymentAllocation>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    collectionsEnableDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    closeoutDate?: string;
    /**
     * Creation timestamp of the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccountStatementDetailCollectionClaim
     */
    created?: string;
}

export function CollectionPatientAccountStatementDetailCollectionClaimFromJSON(json: any): CollectionPatientAccountStatementDetailCollectionClaim {
    return {
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'patientResponsibilityAmount': !exists(json, 'patientResponsibilityAmount') ? undefined : AmountFromJSON(json['patientResponsibilityAmount']),
            'pendingPatientResponsibilityAmount': !exists(json, 'pendingPatientResponsibilityAmount') ? undefined : AmountFromJSON(json['pendingPatientResponsibilityAmount']),
            'patientAmount': !exists(json, 'patientAmount') ? undefined : AmountFromJSON(json['patientAmount']),
            'patientAllocatedAmount': !exists(json, 'patientAllocatedAmount') ? undefined : AmountFromJSON(json['patientAllocatedAmount']),
            'discountAdjustmentAmount': !exists(json, 'discountAdjustmentAmount') ? undefined : AmountFromJSON(json['discountAdjustmentAmount']),
            'writeOffAdjustmentAmount': !exists(json, 'writeOffAdjustmentAmount') ? undefined : AmountFromJSON(json['writeOffAdjustmentAmount']),
            'claimAdjudicationStatus': !exists(json, 'claimAdjudicationStatus') ? undefined : json['claimAdjudicationStatus'],
            'guarantorAdjudicationStatus': !exists(json, 'guarantorAdjudicationStatus') ? undefined : json['guarantorAdjudicationStatus'],
            'fromDos': !exists(json, 'fromDos') ? undefined : json['fromDos'],
            'throughDos': !exists(json, 'throughDos') ? undefined : json['throughDos'],
            'patientFacingMemo': !exists(json, 'patientFacingMemo') ? undefined : json['patientFacingMemo'],
            'serviceLineInfo': !exists(json, 'serviceLineInfo') ? undefined : CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfoFromJSON(json['serviceLineInfo']),
            'collectionPaymentAllocations': !exists(json, 'collectionPaymentAllocations') ? undefined : (json['collectionPaymentAllocations'] as Array<any>).map(CollectionPatientAccountStatementDetailCollectionPaymentAllocationFromJSON),
            'collectionsEnableDate': !exists(json, 'collectionsEnableDate') ? undefined : json['collectionsEnableDate'],
            'closeoutDate': !exists(json, 'closeoutDate') ? undefined : json['closeoutDate'],
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function CollectionPatientAccountStatementDetailCollectionClaimToForm(value?: CollectionPatientAccountStatementDetailCollectionClaim): any {
    let jsonVal = CollectionPatientAccountStatementDetailCollectionClaimToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function CollectionPatientAccountStatementDetailCollectionClaimToJSON(value?: CollectionPatientAccountStatementDetailCollectionClaim): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'patientResponsibilityAmount': AmountToJSON(value.patientResponsibilityAmount),
            'pendingPatientResponsibilityAmount': AmountToJSON(value.pendingPatientResponsibilityAmount),
            'patientAmount': AmountToJSON(value.patientAmount),
            'patientAllocatedAmount': AmountToJSON(value.patientAllocatedAmount),
            'discountAdjustmentAmount': AmountToJSON(value.discountAdjustmentAmount),
            'writeOffAdjustmentAmount': AmountToJSON(value.writeOffAdjustmentAmount),
            'claimAdjudicationStatus': cleanupBlankValuesForBackend(value.claimAdjudicationStatus),
            'guarantorAdjudicationStatus': cleanupBlankValuesForBackend(value.guarantorAdjudicationStatus),
            'fromDos': cleanupBlankValuesForBackend(value.fromDos),
            'throughDos': cleanupBlankValuesForBackend(value.throughDos),
            'patientFacingMemo': cleanupBlankValuesForBackend(value.patientFacingMemo),
            'serviceLineInfo': CollectionPatientAccountStatementDetailCollectionClaimServiceLineInfoToJSON(value.serviceLineInfo),
            'collectionPaymentAllocations': (value.collectionPaymentAllocations === undefined || value.collectionPaymentAllocations === null) ? undefined : (value.collectionPaymentAllocations as Array<any>).map(CollectionPatientAccountStatementDetailCollectionPaymentAllocationToJSON),
            'collectionsEnableDate': cleanupBlankValuesForBackend(value.collectionsEnableDate),
            'closeoutDate': cleanupBlankValuesForBackend(value.closeoutDate),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


